/* MONO Velours launch: sticky buy bar (mobile). Shown while scrolling, hidden while a buy area is on screen. */
(function () {
  function init() {
    var sticky = document.querySelector('[data-mono-sticky]');
    if (!sticky || sticky.dataset.ready) return;
    sticky.dataset.ready = 'true';
    sticky.hidden = false;
    document.body.classList.add('has-mono-sticky');
    var zones = document.querySelectorAll('[data-buy-zone]');
    if (!zones.length || !('IntersectionObserver' in window)) return;
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? visible.add(e.target) : visible.delete(e.target); });
      sticky.classList.toggle('is-hidden', visible.size > 0);
    }, { threshold: 0.35 });
    zones.forEach(function (z) { io.observe(z); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
